import { ITEMS } from '../data/items';

export interface ShippingEntry {
  itemId: string;
  qty: number;
}

/** Add produce to the shipping bin, merging stacks. Pure (returns new array). */
export function addToShipping(bin: ShippingEntry[], itemId: string, qty: number): ShippingEntry[] {
  const next = bin.map((e) => ({ ...e }));
  const existing = next.find((e) => e.itemId === itemId);
  if (existing) existing.qty += qty;
  else next.push({ itemId, qty });
  return next;
}

export function shippingValue(bin: ShippingEntry[], bonusItem?: string, bonusMult = 1.5): number {
  return bin.reduce((sum, e) => {
    const def = ITEMS[e.itemId];
    if (!def) return sum;
    const mult = bonusItem && e.itemId === bonusItem ? bonusMult : 1;
    return sum + Math.round(def.sellPrice * mult) * e.qty;
  }, 0);
}

/** Buy: deduct the price if affordable. Pure. */
export function purchase(money: number, price: number): { money: number; ok: boolean } {
  if (money < price) return { money, ok: false };
  return { money: money - price, ok: true };
}

/** Day-end payout: credit the bin's value and empty it. Pure. */
export function settleShipping(
  money: number,
  bin: ShippingEntry[],
  bonusItem?: string,
): { money: number; earned: number; bin: ShippingEntry[] } {
  const earned = shippingValue(bin, bonusItem);
  return { money: money + earned, earned, bin: [] };
}
